import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import MonsterDescription from './MonsterDescription.vue';
const monsterModule = namespace('monsters');
let MonsterDetail = class MonsterDetail extends Vue {
    created() {
        this.fetchMonsters();
    }
    get title() {
        return this.monsterName + Vue.prototype.$titleSuffix;
    }
    get monster() {
        return this.monsters.find(({ name }) => name === this.monsterName);
    }
};
__decorate([
    monsterModule.State
], MonsterDetail.prototype, "monsters", void 0);
__decorate([
    monsterModule.Action
], MonsterDetail.prototype, "fetchMonsters", void 0);
__decorate([
    Prop(String)
], MonsterDetail.prototype, "monsterName", void 0);
MonsterDetail = __decorate([
    Component({
        components: {
            MonsterDescription
        }
    })
], MonsterDetail);
export default MonsterDetail;
